var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73145 2.2959C8.11865 1.82617 8.3916 1.18506 8.3916 0.537598C8.3916 0.44873 8.38525 0.359863 8.37256 0.290039C7.73779 0.31543 6.97607 0.708984 6.52539 1.24219C6.16357 1.64844 5.8335 2.2959 5.8335 2.94336C5.8335 3.04492 5.85254 3.14014 5.85889 3.17188C5.89697 3.17822 5.96045 3.19092 6.03027 3.19092C6.59521 3.19092 7.30615 2.81006 7.73145 2.2959ZM8.17578 3.32422C7.22998 3.32422 6.45557 3.90186 5.96045 3.90186C5.43359 3.90186 4.74805 3.3623 3.92285 3.3623C2.35498 3.3623 0.768066 4.65723 0.768066 7.09473C0.768066 8.61816 1.35205 10.2241 2.08203 11.2588C2.7041 12.1348 3.25 12.8521 4.03711 12.8521C4.81152 12.8521 5.1543 12.3379 6.11914 12.3379C7.09668 12.3379 7.31885 12.8394 8.17578 12.8394C9.02637 12.8394 9.59131 12.0586 10.1309 11.2905C10.7275 10.4082 10.9814 9.55127 10.9878 9.50684C10.937 9.49414 9.31201 8.82764 9.31201 6.96777C9.31201 5.35547 10.5879 4.63184 10.6641 4.57471C9.81982 3.3623 8.53125 3.32422 8.17578 3.32422Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.dde49629a9b2b8399fe6f79b63ca176c.svg";
export { ForwardRef as ReactComponent };